import getJWT from './getJWT';

const bucketDownloader = async (imageName) => {
  const filename = imageName.split('.s3.amazonaws.com/').pop();
  const urlBase = process.env.REACT_APP_APIURL;

  try {
    const response = await fetch(
      `${urlBase}/download_apto_medico/${filename}`,
      {
        method: 'GET',
        headers: {
          'X-Access-Tokens': getJWT(),
        },
      }
    );

    const result = await response.json();

    if (!response.ok || !result.url) {
      throw new Error(result.error || 'Error al obtener la imagen');
    }

    return result.url;

  } catch (error) {
    console.error('Error al descargar el apto médico:', error);
  }
};

export default bucketDownloader;
